import React from "react";

export interface ILogoProps {
  type?: "default" | "long";
  width?: number;
  height?: number;
}

const LOGO_DEFAULT = {
  width: 69,
  height: 30,
};
const LOGO_LONG = {
  width: 118,
  height: 28,
};

const Logo: React.FC<ILogoProps> = ({ type = "default", width, height }) => {
  let w = type === "default" ? LOGO_DEFAULT.width : LOGO_LONG.width;
  let h = type === "default" ? LOGO_DEFAULT.height : LOGO_LONG.height;

  if (width || height) {
    if (!width && typeof height === "number") {
      w = height * (w / h);
      h = height;
    } else if (!height && typeof width === "number") {
      w = width;
      h = width * (h / w);
    }
  }

  return (
    <img
      src={
        type === "default"
          ? "/v2-icon/logo-default.svg"
          : "/v2-icon/logo-long.svg"
      }
      alt="logo-long"
      width={w}
      height={h}
    />
  );
};

export default Logo;
